import { render, staticRenderFns } from "./age2.vue?vue&type=template&id=99f991f6&scoped=true"
import script from "./age2.vue?vue&type=script&lang=js"
export * from "./age2.vue?vue&type=script&lang=js"
import style0 from "./age2.vue?vue&type=style&index=0&id=99f991f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f991f6",
  null
  
)

export default component.exports